module.exports = __webpack_public_path__ + "img/personalData.bb8ff6a2.svg";